export default () => (
  /**
   * Ícone "X" com contorno circular
   * com preenchimento na cor vermelha
   * simbolizando erro ou falha
   */
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5298 20C4.99645 20 0.552002 15.5111 0.552002 10.0222C0.552002 4.53333 4.99645 0 10.5298 0C16.0631 0 20.5076 4.48889 20.5076 9.97778C20.5076 15.4667 16.0631 20 10.5298 20ZM10.5298 1.06667C5.64089 1.06667 1.61867 5.06667 1.61867 9.97778C1.61867 14.8889 5.64089 18.8889 10.5298 18.8889C15.4187 18.8889 19.4409 14.8889 19.4409 9.97778C19.4409 5.06667 15.4187 1.06667 10.5298 1.06667Z"
      fill="#C24938"
    />
    <path
      d="M5.71816 15.3327C5.5966 15.3327 5.47504 15.2922 5.35348 15.1706C5.15089 14.968 5.15089 14.6844 5.35348 14.4818L15.0173 4.81796C15.2199 4.61537 15.5035 4.61537 15.7061 4.81796C15.9087 5.02056 15.9087 5.30419 15.7061 5.50679L6.10309 15.2111C5.96127 15.2922 5.83971 15.3327 5.71816 15.3327Z"
      fill="#C24938"
    />
    <path
      d="M15.3618 15.3117C15.2403 15.3117 15.1187 15.2712 14.9972 15.1496L5.35361 5.52632C5.15101 5.32372 5.15101 5.04009 5.35361 4.83749C5.5562 4.6349 5.83984 4.6349 6.04243 4.83749L15.7063 14.5013C15.9088 14.7039 15.9088 14.9875 15.7063 15.1901C15.605 15.2712 15.4834 15.3117 15.3618 15.3117Z"
      fill="#C24938"
    />
  </svg>
);
